var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chips__supplied"},_vm._l((_vm.getValueComputed),function(item,index){return _c('span',{staticClass:"chip__wrap"},[_vm._v(_vm._s(item)+" "),_c('i',{staticClass:"ti-close",on:{"click":function($event){return _vm.removeChip(item)}}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }